/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("@babel/polyfill");
require('./bootstrap');
window.Vue = require('vue');

import VueRouter from 'vue-router'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Navbar from './components/Navbar.vue';
import Footnote from './components/Footnote.vue';
import Slider from './components/Slider.vue';
import Mapsection from './components/Mapsection.vue';
import Appointment from './pages/Appointment.vue';
import Whitepaper from './pages/Whitepaper.vue';
import WhitepaperForm from './components/WhitepaperForm.vue';
import Impressum from './pages/Impressum.vue';
import Dataprivacy from './pages/DataPrivacy.vue';
import Agb from './pages/Agb.vue';
import Newsletter from './pages/Newsletter.vue';
import AOS from 'aos'
import 'aos/dist/aos.css'
import Vue from 'vue'
import VueSplide from '@splidejs/vue-splide';
var VueScrollTo = require('vue-scrollto');
 
Vue.use(VueScrollTo)

Vue.use( VueSplide );

import "@splidejs/splide/dist/css/themes/splide-default.min.css";




AOS.init({
    disable: 'mobile',
    once: false
});

Vue.use(VueRouter)
Vue.use(VueReCaptcha, { siteKey: '6LfMjbIZAAAAACLXa6k3Nr4UZXKFWarIaa-0dTpH' })

const router = new VueRouter({
    mode: 'history',
    root: '/',
    linkActiveClass: "active",
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                offset: {
                    x: 0,
                    y: 58
                }
            }
        } else if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    },
    routes: [
        {
            path: '/termin',
            name: 'termin',
            component: require('./pages/Appointment.vue').default
        },
        {
            path: '/whitepaper',
            name: 'whitepaper',
            component: require('./pages/Whitepaper.vue').default
        },
        {
            path: '/kontaktanfrage',
            name: 'kontaktanfrage',
            component: require('./pages/KontaktAnfrage.vue').default
        },
        {
            path: '/download',
            name: 'download',
            component: require('./pages/Download.vue').default
        },
        {
            path: '/impressum',
            name: 'impressum',
            component: require('./pages/Impressum.vue').default
        },
        {
            path: '/datenschutz',
            name: 'datenschutz',
            component: require('./pages/DataPrivacy.vue').default
        },
        {
            path: '/agb',
            name: 'agb',
            component: require('./pages/Agb.vue').default
        },
        {
            path: '/newsletter',
            name: 'newsletter',
            component: require('./pages/Newsletter.vue').default
        },
        {
            path: '/vielen-dank',
            name: 'vielen-dank',
            component: require('./pages/Newsletter.vue').default
        }
    ]
})

let app = new Vue({
    components: {
        Navbar,
        Footnote,
        Slider,
        Mapsection,
        Appointment,Whitepaper,WhitepaperForm,Impressum,Dataprivacy,Agb,Newsletter
    },
    router: router
}).$mount('#app');
